<script>
  import editalServico from '../../servico';
  import Carregando from '~componentes/Carregando.vue';

  export default {
    name: 'DetalharEdital',
    components: { Carregando },
    data() {
      return {
        edital: {
          idEdital: null,
          tituloEdital: null,
          numeroEdital: null,
          anoEdital: null,
          objetoEdital: null,
          dataHoraCadastroFormatada: null,
          dataHoraCriacaoPublicacaoFormatada: null
        },
        publicacoes: [],
        configuracao: this.$storage.configuracao(),
        carregando: false,
      }
    },
    methods: {
      carregarEdital(id) {
        return editalServico
          .informacaoEdital(id)
          .then(informacaoEdital => {
            this.edital = informacaoEdital;
          });
      },
      carregarPublicacoes(id) {
        return editalServico
          .publicacoesEdital(id)
          .then(publicacoesEdital => {
            this.publicacoes = publicacoesEdital;
          });
      },
      padronizarTituloEdital() {
        return `Edital ${this.edital.numeroEdital}/${this.edital.anoEdital} - ${this.edital.tituloEdital}`;
      },
      voltar() {
        this.$router.push({
          name: 'editais',
          query: this.$route.query
        });
      },
    },
    computed: {

    },
    mounted() {
      this.$root.tituloDaPagina = `Edital`;
      this.carregando = true;
      this.carregarEdital(this.$route.params.id);
      this.carregarPublicacoes(this.$route.params.id);
      this.carregando = false;
    },
  }
</script>

<template>
  <div>

    <Carregando v-if="carregando"></Carregando>

    <div class="row" v-if="!carregando">
      <div class="col-xs-12">

        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <div class="row">
              <dl class="col-md-12">
                <dt>Título</dt>
                <dd>{{ padronizarTituloEdital() }}</dd>
              </dl>
            </div>

            <div class="row">
              <dl class="col-xs-12">
                <dt>Objetivo</dt>
                <dd class="white-space-pre">{{ edital.objetoEdital || '---' }}</dd>
              </dl>
            </div>

            <div class="row">
              <dl class="col-md-2">
                <dt>Número</dt>
                <dd>{{ edital.numeroEdital || '---' }}</dd>
              </dl>
              <dl class="col-md-2">
                <dt>Ano</dt>
                <dd>{{ edital.anoEdital || '---' }}</dd>
              </dl>
              <dl class="col-md-4">
                <dt>Data de postagem</dt>
                <dd>{{ edital.dataHoraCadastroFormatada || '---' }}</dd>
              </dl>
              <dl class="col-md-4">
                <dt>Data da última atualização</dt>
                <dd>{{ edital.dataHoraCriacaoPublicacaoFormatada || '---' }}</dd>
              </dl>
            </div>

            <div class="row">
              <div class="col-xs-12">
                <dt>Publicações</dt>
                <div class="table-responsive margin-top-5">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Publicação</th>
                        <th>Data</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="publicacao in publicacoes">
                        <td>{{ publicacao.nomeTipoPublicacaoEdital }}</td>
                        <td>{{ publicacao.dataHoraCriacaoPublicacaoFormatada }}</td>
                      </tr>
                      <tr v-if="publicacoes.length === 0 && !carregando">
                        <td colspan="5" class="text-center">Nenhuma publicação registrada.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!--<div v-if="mostrarAnexosProjeto">
              <div style="border-top: 1px solid #ccc; padding-bottom: 12px;" />
              <div class="row" style="padding-bottom: 6px;">
                <h3 class="col-xs-12"><b>Anexos do projeto</b></h3>
              </div>

              <div class="row" style="padding-bottom: 6px;">
                <div class="col-xs-12">
                  <div class="table-responsive">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>Documento</th>
                          <th>Visualizar/Download</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="arquivo in arquivos">
                          <td>{{ nomeArquivo(arquivo) }}</td>
                          <td class="action">
                            <button type="button"
                                    class="btn btn-default btn-xs"
                                    @click="download(arquivo)">
                              <i class="fa fa-download"></i>
                            </button>
                          </td>
                        </tr>
                        <tr v-if="arquivos.length === 0 && !carregando">
                          <td colspan="2" class="text-center">Nenhum arquivo encontrado.</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>-->

          </div>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="col-md-12 flex-container" style="justify-content:end; margin-bottom:25px">
        <button class="btn btn-primary"
                @click="voltar">
          <i class="fa fa-arrow-left"></i> Voltar
        </button>
      </div>
    </div>
  </div>
</template>
<style>
.botao-relatorio{
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (min-width: 1500px) {
  .col-tela-grande {
    width: 20%;
  }
}
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/edital/componentes/compartilhado/DetalharEdital.vue